import { render, staticRenderFns } from "./UrgentTicketForm.vue?vue&type=template&id=1151875f&scoped=true&"
import script from "./UrgentTicketForm.vue?vue&type=script&lang=js&"
export * from "./UrgentTicketForm.vue?vue&type=script&lang=js&"
import style0 from "./UrgentTicketForm.vue?vue&type=style&index=0&id=1151875f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1151875f",
  null
  
)

export default component.exports